import React, { useState, useEffect } from 'react';
import ActivityCard from '../components/ActivityCard';
import '../styles/Activities.css';

const Activities = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);

  // Fonction pour générer une image de placeholder basée sur le titre
  const generatePlaceholderImage = (title, category) => {
    const colors = {
      'Culture': '27ae60',       // Emerald Green
      'Éducation': 'd63031',     // Crimson Red
      'Solidarité': '2ecc71',    // Light Green
      'Business': 'f1c40f',      // Gold
      'Social': '2ecc71',        // Light Green
      'Sport': 'e67e22',         // Amber
      'Syndicat': 'b71c1c',      // Dark Crimson
      'Formation': 'd63031',     // Crimson Red
      'Institutionnel': '1e293b',// Slate Dark
      'Orientation': 'f1c40f'    // Gold
    };

    const color = colors[category] || 'd63031';
    const label = title.substring(0, 30).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&apos;'
    })[character]);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="500" viewBox="0 0 800 500"><rect width="800" height="500" fill="#${color}"/><text x="400" y="250" fill="#ffffff" font-family="sans-serif" font-size="30" text-anchor="middle">${label}</text></svg>`;
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  };

  let activities = [
    {
      id: 1,
      title: "Assemblée Générale et Élection du Bureau",
      date: "2025-07-20",
      description: "Moment fort marquant le renouvellement du bureau exécutif de l'ASB.",
      image: "/images/AG_election_2025/bureau.jpg",
      placeholder: generatePlaceholderImage("Assemblée Générale et Élection du Bureau", "Institutionnel"),
      location: "ESMT Dakar",
      category: "Institutionnel"
    },
    {
      id: 2,
      title: "Passation du Bureau",
      date: "2025-08-01",
      description: "Ce moment symbolique marque le transfert officiel des responsabilités entre l'ancien et le nouveau bureau de l'ASB.",
      image: "/images/passation_2025/passation.jpg",
      placeholder: generatePlaceholderImage("Passation du Bureau", "Institutionnel"),
      location: "EISMV Dakar",
      category: "Institutionnel"
    },
    {
      id: 3,
      title: "Rentrée Syndicale",
      date: "2024-12-01",
      description: "Lancement officiel des activités du nouveau comité exécutif, accueil des nouveaux étudiants et adoption du programme d'activités.",
      image: "/images/rentree_syndicale_2024/rentree.jpg",
      placeholder: generatePlaceholderImage("Rentrée Syndicale", "Syndicat"),
      location: "ESMT Dakar",
      category: "Syndicat"
    },
    {
      id: 4,
      title: "Formation - Méthodologie de recherche et rédaction scientifique",
      date: "2025-02-15",
      description: "Formation des militants sur la méthodologie de recherche et de rédaction scientifique animée par le camarade Alassane Ouattara.",
      image: "/images/redaction_administrative/redaction.jpg",
      images: [
        "/images/redaction_administrative/redaction.jpg",
        "/images/redaction_administrative/redaction2.jpg",
        "/images/redaction_administrative/redaction3.jpg",
        "/images/redaction_administrative/redaction4.jpg"
      ],
      placeholder: generatePlaceholderImage("Formation - Méthodologie de recherche", "Formation"),
      location: "Ambassade du Burkina Faso à Dakar",
      category: "Formation"
    },
    {
      id: 5,
      title: "Audience avec l'Ambassadeur",
      date: "2025-01-24",
      description: "Présentation des nouveaux membres du bureau, dépôt de la plateforme revendicative et demande de prolongement des bourses.",

      placeholder: generatePlaceholderImage("Audience avec l'Ambassadeur", "Institutionnel"),
      location: "Ambassade du Burkina Faso au Sénégal",
      category: "Institutionnel"
    },
    {
      id: 6,
      title: "Journée de l'Étudiant Burkinabè",
      date: "2025-05-24",
      description: "Conférence en ligne sur le thème : « De l'engagement à la détermination d'un martyr : cas de Dabo Boukary », animée par le camarade HEBIE Oumarou.",
      image: "/images/drapeau.png",
      placeholder: generatePlaceholderImage("Journée de l'Étudiant Burkinabè", "Culture"),
      location: "En ligne",
      category: "Culture"
    },
    {
      id: 7,
      title: "Rupture collective",
      date: "2025-03-15",
      description: "Rupture collective organisée avec la FEFAS à la résidence de l'Ambassadeur dans le cadre du jeûne.",
      image: "/images/rupture_collective_2025/rupture_collective.jpg",
      placeholder: generatePlaceholderImage("Rupture collective", "Solidarité"),
      location: "Résidence de l'Ambassadeur",
      category: "Solidarité"
    },
    {
      id: 8,
      title: "Carrefour des Métiers",
      date: "2025-06-01",
      description: "Participation à l'activité de l'ABONUPS à l'ambassade du Burkina Faso au Sénégal pour l'orientation professionnelle des étudiants.",
      image: "/images/carrefour_metier_2025/metier.jpg",
      placeholder: generatePlaceholderImage("Carrefour des Métiers", "Orientation"),
      location: "Ambassade du Burkina Faso au Sénégal",
      category: "Orientation"
    },
    {
      id: 9,
      title: "Journée Internationale de la Femme (UFBS)",
      date: "2025-05-11",
      description: "Participation de l'ASB à la célébration différée de la journée internationale de la femme avec l'Union des Femmes Burkinabè au Sénégal.",
      placeholder: generatePlaceholderImage("Journée Internationale de la Femme", "Social"),
      location: "Dakar",
      category: "Social"
    },
    {
      id: 10,
      title: "Audience avec Son Excellence Saïdou MAÏGA",
      date: "2026-02-04",
      description: "Reçue par l'Ambassadeur du Burkina Faso au Sénégal, la délégation de l'ASB a présenté le bureau et sa plateforme revendicative, et échangé sur la situation générale des étudiants burkinabè au Sénégal.",
      image: "/images/audiance_ambassadeur_2026/audience-ambassade-2026.jpg",
      images: [
        "/images/audiance_ambassadeur_2026/audience-ambassade-2026.jpg",
        "/images/audiance_ambassadeur_2026/audience-ambassadeur.jpg",
        "/images/audiance_ambassadeur_2026/audiance_ambassadeur2.jpg"
      ],
      placeholder: generatePlaceholderImage("Audience avec Son Excellence Saïdou MAÏGA", "Institutionnel"),
      location: "Ambassade du Burkina Faso au Sénégal",
      category: "Institutionnel"
    },
    {
      id: 11,
      title: "Soirée Fitness — Sport Aérobie",
      date: "2026-02-07",
      description: "Une soirée sportive conviviale sur la Corniche Ouest, alliant exercice physique, détente et esprit de camaraderie entre les membres de l'association.",
      image: "/images/sport_aerobie_2026_1/sport-aerobie.jpg",
      images: [
        "/images/sport_aerobie_2026_1/sport-aerobie.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-2.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-3.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-4.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-5.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-6.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-7.jpg",
        "/images/sport_aerobie_2026_1/sport-aerobie-8.jpg"
      ],
      placeholder: generatePlaceholderImage("Soirée Fitness — Sport Aérobie", "Sport"),
      location: "Corniche Ouest, Dakar",
      category: "Sport"
    },
    {
      id: 12,
      title: "Webinaire — Épanouissement de la Femme et Harmonie Sociale",
      date: "2026-03-08",
      description: "À l'occasion de la Journée internationale des droits de la femme, un webinaire réunissant des intervenantes inspirantes autour du développement personnel et du leadership féminin.",
      image: "/images/webinaires/webinaire-8-mars.jpg",
      placeholder: generatePlaceholderImage("Épanouissement de la Femme et Harmonie Sociale", "Social"),
      location: "En ligne (Google Meet)",
      category: "Social"
    },
    {
      id: 13,
      title: "Webinaire sur la cyber-sécurité ",
      date: "2026-02-08",
      description: "Ce webinaire organisé sous le thème « Un futur dirigé par l’IA : La fin de la cybersécurité ou une opportunité de la repenser ? »  a eté animé par Childeric YAMEOGO",
      image: "/images/webinaires/webinaire_securite.jpeg",
      placeholder: generatePlaceholderImage("Épanouissement de la Femme et Harmonie Sociale", "Social"),
      location: "En ligne (Google Meet)",
      category: "Social"
    },
    {
      id: 14,
      title: "Webinaire sur l'intelligence artificielle",
      date: "2025-12-21",
      description: "Dans ce webinaire il s'agissait d'apprendre à éviter la dépendance à l'IA et de savoir comment l'utiliser à bon escient. Il a été animé par YAMEOGO A. M. KISWENDSIDA 1ER Jumeau",
      image: "/images/webinaires/webinaire_IA1.jpeg",
      images: [
        "/images/webinaires/webinaire_IA1.jpeg",
        "/images/webinaires/webinaire_IA2.jpg",
        "/images/webinaires/webinaire_IA3.jpg"
      ],
      placeholder: generatePlaceholderImage("Épanouissement de la Femme et Harmonie Sociale", "Social"),
      location: "En ligne (Google Meet)",
      category: "Social"
    },

    {
      id: 15,
      title: "Rupture Collective — Foi, Fraternité et Vivre-Ensemble",
      date: "2026-03-14",
      description: "Rupture collective organisée avec le C.E.M.V.D et le CEERK au Foyer du Véto, un moment de partage et de convivialité autour de la rupture du jeûne.",
      image: "/images/rupture_collective_2026/rupture1.jpg",
      images: [
        "/images/rupture_collective_2026/rupture1.jpg",
        "/images/rupture_collective_2026/rupture2.jpeg",
        "/images/rupture_collective_2026/rupture3.jpeg",
        "/images/rupture_collective_2026/rupture4.jpeg",
        "/images/rupture_collective_2026/rupture5.jpeg",
        "/images/rupture_collective_2026/rupture6.jpeg"
      ],
      location: "Foyer du Véto, Dakar",
      category: "Solidarité"
    }
    ,

    {
      id: 16,
      title: "Webinaire sur la prévention du cancer de sein",
      date: "2026-10-17",
      description: "",
      image: "/images/webinaires/webinaire_cancer_2026.jpeg",
      location: "Foyer du Véto, Dakar",
      category: "Solidarité"
    },
    {
      id: 17,
      title: "Rentrée Syndicale 2026",
      date: "2025-10-09",
      description: "Retour en images sur la rentrée syndicale de l'ASB.",
      image: "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.28.jpeg",
      images: [
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.28.jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.28 (1).jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.29.jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.29 (1).jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.30.jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.30 (1).jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.30 (2).jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.39.jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.39 (1).jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.39 (2).jpeg",
        "/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.39 (3).jpeg"
      ],
      placeholder: generatePlaceholderImage("Rentrée Syndicale 2026", "Syndicat"),
      location: "Dakar",
      category: "Syndicat"
    }
  ];

  // Trier les activités de la plus récente à la moins récente
  activities = activities.sort((a, b) => new Date(b.date) - new Date(a.date));

  // Animation d'apparition progressive
  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleCards(prev => {
        if (prev.length < activities.length) {
          return [...prev, prev.length];
        }
        clearInterval(timer);
        return prev;
      });
    }, 200);

    return () => clearInterval(timer);
  }, [activities.length]);

  useEffect(() => {
    if (!selectedActivity) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setSelectedActivity(null);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [selectedActivity]);

  // Formatage de date
  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  const getActivityImages = (activity) => {
    if (Array.isArray(activity.images) && activity.images.length > 0) {
      return activity.images;
    }
    if (Array.isArray(activity.image)) {
      return activity.image;
    }
    return activity.image ? [activity.image] : [];
  };

  return (
    <div className="activities-container">
      {/* Hero Section */}
      <div className="activities-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <div className="badge-indicator"></div>
            <span className="badge-text">Événements & Actions</span>
          </div>

          <h1 className="hero-title">Nos Activités</h1>

          {/* Statistiques simplifiées */}
          <div className="stats-container">

          </div>
        </div>
      </div>

      {/* Liste des activités */}
      <div className="activities-section">
        <div className="activities-grid">
          {activities.map((activity, index) => (
            <div
              key={activity.id}
              className={`activity-wrapper ${visibleCards.includes(index) ? 'visible' : ''
                }`}
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <ActivityCard
                activity={activity}
                formatDate={formatDate}
                onSelect={() => setSelectedActivity(activity)}
              />
            </div>
          ))}
        </div>
      </div>

      {selectedActivity && (
        <div
          className="activity-modal-backdrop"
          onClick={() => setSelectedActivity(null)}
        >
          <section
            className="activity-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="activity-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="activity-modal-close"
              type="button"
              aria-label="Fermer les détails de l’activité"
              onClick={() => setSelectedActivity(null)}
            >
              &times;
            </button>
            <div className="activity-modal-heading">
              <span className="activity-modal-category">{selectedActivity.category}</span>
              <h2 id="activity-modal-title">{selectedActivity.title}</h2>
              <p>{formatDate(selectedActivity.date)} · {selectedActivity.location}</p>
              <p>{selectedActivity.description}</p>
            </div>
            <div className="activity-gallery">
              {getActivityImages(selectedActivity).length > 0 ? (
                getActivityImages(selectedActivity).map((image, index) => (
                  <figure className="activity-gallery-item" key={image}>
                    <img src={image} alt={`${selectedActivity.title} — ${index + 1}`} />
                    <a
                      className="activity-download"
                      href={image}
                      download
                    >
                      Télécharger la photo {index + 1}
                    </a>
                  </figure>
                ))
              ) : (
                <p className="activity-gallery-empty">Aucune photo disponible pour cette activité pour le moment.</p>
              )}
            </div>
          </section>
        </div>
      )}

      {/* CTA Section */}

      {/* Éléments décoratifs */}
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
    </div>
  );
};

export default Activities;